<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "ROLEDETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon
      alt="Exit"
        class="exit"
        role="button"
        src="assets/device/exit.svg"
      ></svg-icon>
    </div>
  </div>

  <div class="row g-0 m-0 body p-4">
    <div class="member-details p-4">
      <div class="row g-0 m-0">
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "ROLENAME" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ role.name }}</span>
          </div>
        </div>
      </div>
      <div class="row g-0 m-0">
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "TOTALPERMISSIONS" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ role.permissions?.length }}</span>
          </div>
        </div>
      </div>
      <!--      <div-->
      <!--        class="row g-0 m-0 pt-2 pb-2 d-flex justify-content-start align-items-center"-->
      <!--      >-->
      <!--        <div class="col-md-6">-->
      <!--          <span class="item-name">{{ "STATUS" | translate }}</span>-->
      <!--        </div>-->
      <!--        <div class="col-md-6 d-flex">-->
      <!--          <span-->
      <!--            class="status"-->
      <!--            [ngClass]="{-->
      <!--              active: role.status === 'Active',-->
      <!--              pending: role.status === 'Pending',-->
      <!--              inactive: role.status === 'Inactive',-->
      <!--            }"-->
      <!--            >{{ role.status }}</span-->
      <!--          >-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row g-0 m-0">
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "CREATEDBY" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ role.createdByUserEmail }}</span>
          </div>
        </div>
      </div>
      <div class="row g-0 m-0">
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "DATECREATED" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{
              role.createdTime | date: "d MMMM, y"
            }}</span>
          </div>
        </div>
      </div>
    </div>
    @if (role.permissions?.length !== 0) {
      <span class="sidemenu-title pb-3 pt-3">{{
        "ASSIGNEDPERMISSIONS" | translate
      }}</span>
      <div class="category-container p-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="item-name">{{ "SIDEBAR_DEVICE" | translate }}</span>
        </div>
        <div class="row g-0 mt-2 permission-container p-3">
          @for (permission of role.permissions; track permission) {
            <div class="col-6 g-0 m-0 p-2 ps-3 permision">
              <div class="d-flex align-items-center">
                <span>{{ formatPermission(permission) }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <span class="sidemenu-title pb-3 pt-3">{{
        "ASSIGNEDPERMISSIONS" | translate
      }}</span>
      <div class="category-container p-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="item-name">{{ "NONE" | translate }}</span>
        </div>
      </div>
    }
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
    <div
      class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start"
      (click)="toggleModal()"
    >
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
      }}</span>
    </div>
  </div>
</div>
